import React, {useState, useEffect} from 'react';
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  Stack,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import {Link, useLocation} from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu'; // Import MenuIcon for hamburger menu
import './Navbar.css'; // Import CSS file
import sst_logo from '../images/sst_logo.png';

const Navbar = () => {
  const [open, setOpen] = useState (false); // State to manage Drawer (hamburger menu)
  const [selectedItem, setSelectedItem] = useState ('Home');
  const location = useLocation ();
  // Sync selectedItem with current route
  useEffect (
    () => {
      switch (location.pathname) {
        case '/':
          setSelectedItem ('Home');
          break;
        case '/about':
          setSelectedItem ('About');
          break;
        case '/contact':
          setSelectedItem ('Contact');
          break;
        case '/register':
          setSelectedItem ('Register');
          break;
        case '/privacy-policy':
          setSelectedItem ('Privacy Policy');
          break;
        default:
          setSelectedItem ('');
      }
    },
    [location.pathname]
  );

  // Toggle Drawer open/close
  const toggleDrawer = () => {
    setOpen (!open);
  };

  const handleButtonClick = item => {
    setSelectedItem (item);
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: 'rgba(255, 255, 255, 1)',
        borderRadius: 12,
        width: {xs: '98%', sm: '95%', md: '92%'}, // Adjust width for different screens
        left: '50%',
        transform: 'translateX(-50%)',
        top: 20,
        padding: {xs: 0.2, sm: 0.3, md: 0.5, lg: 1, xl: 1}, // Adjust padding
      }}
    >
      <Toolbar
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: {xs: 'row', sm: 'row'}, // Stack items on smaller screens
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Box
          component="a"
          href="https://www.sstus.net/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={sst_logo}
            alt="SST Logo"
            style={{
              width: '25%', // Adjust this as needed
            }}
          />
        </Box>

        {/* Logo Section */}
        <Box>
          <img
            src="/llminsight2.png"
            className="logo_image"
            alt="LLM Insight Logo"
          />
        </Box>

        {/* Hamburger Menu for Mobile */}
        <IconButton
          sx={{display: {xs: 'block', sm: 'none'}}} // Display only on mobile
          onClick={toggleDrawer}
        >
          <MenuIcon />
        </IconButton>

        {/* Desktop Navigation */}
        <Stack
          direction="row"
          spacing={{xs: 1, sm: 2, md: 3}}
          sx={{display: {xs: 'none', sm: 'flex'}}} // Hide on small screens
        >
          <Button
            // color="primary"
            component={Link}
            onClick={() => handleButtonClick ('Home')}
            to="/"
            sx={{
              fontFamily: 'Light',
              color: '#002367',
              fontWeight: 'bold',
              textTransform: 'none',
              fontSize: {xs: 14, sm: 18},
              // border: selectedItem === "Home" && "1px solid #969696",
              borderRadius: selectedItem === 'Home' ? 25 : 0,
              backgroundColor: selectedItem === 'Home' && '#def0fc',
              paddingX: selectedItem === 'Home' ? 2 : 0,
            }}
          >
            Home
          </Button>
          <Button
            color="primary"
            component={Link}
            onClick={() => handleButtonClick ('About')}
            to="/about"
            sx={{
              fontFamily: 'Light',
              color: '#002367',
              fontWeight: 'bold',
              textTransform: 'none',
              fontSize: {xs: 14, sm: 18},
              // border: selectedItem === "About" && "1px solid #969696",
              borderRadius: selectedItem === 'About' ? 25 : 0,
              backgroundColor: selectedItem === 'About' && '#def0fc',
              paddingX: selectedItem === 'About' ? 2 : 0,
            }}
          >
            About Us
          </Button>
          <Button
            color="primary"
            component={Link}
            onClick={() => handleButtonClick ('Contact')}
            to="/contact"
            sx={{
              fontFamily: 'Light',
              color: '#002367',
              fontWeight: 'bold',
              textTransform: 'none',
              fontSize: {xs: 14, sm: 18},
              // border: selectedItem === "Contact" && "1px solid #969696",
              borderRadius: selectedItem === 'Contact' ? 25 : 0,
              backgroundColor: selectedItem === 'Contact' && '#def0fc',
              paddingX: selectedItem === 'Contact' ? 2 : 0,
            }}
          >
            Contact
          </Button>
          <Button
            color="primary"
            component={Link}
            onClick={() => handleButtonClick ('Register')}
            to="/register"
            sx={{
              fontFamily: 'Light',
              color: '#002367',
              fontWeight: 'bold',
              textTransform: 'none',
              fontSize: {xs: 14, sm: 18},
              borderRadius: selectedItem === 'Register' ? 25 : 0,
              backgroundColor: selectedItem === 'Register' && '#def0fc',
              paddingX: selectedItem === 'Register' ? 2 : 0,
            }}
          >
            Register Organization
          </Button>
          <Button
            color="primary"
            component={Link}
            onClick={() => handleButtonClick ('Privacy Policy')}
            to="/privacy-policy"
            sx={{
              fontFamily: 'Light',
              color: '#002367',
              fontWeight: 'bold',
              textTransform: 'none',
              fontSize: {xs: 14, sm: 18},
              borderRadius: selectedItem === 'Privacy Policy' ? 25 : 0,
              backgroundColor: selectedItem === 'Privacy Policy' && '#def0fc',
              paddingX: selectedItem === 'Privacy Policy' ? 2 : 0,
            }}
          >
            Privacy Policy
          </Button>

        </Stack>
      </Toolbar>

      {/* Drawer (Hamburger Menu) for Mobile */}
      <Drawer anchor="right" open={open} onClose={toggleDrawer}>
        <Box sx={{width: 200}} role="presentation">
          <List>
            <ListItem button onClick={toggleDrawer}>
              <ListItemText>
                <Link to="/" onClick={toggleDrawer}>
                  <Typography
                    className="features-title"
                    sx={{
                      color: '#002367',
                      fontFamily: 'Light',
                      fontSize: {xs: 14, sm: 16, md: 18}, // Responsive font size
                      fontWeight: '700',
                      lineHeight: '35px',
                      justifySelf: 'center',
                    }}
                  >
                    Home
                  </Typography>
                </Link>
              </ListItemText>
            </ListItem>
            <ListItem button onClick={toggleDrawer}>
              <ListItemText>
                <Link to="/about" onClick={toggleDrawer}>
                  <Typography
                    className="features-title"
                    sx={{
                      color: '#002367',
                      fontFamily: 'Light',
                      fontSize: {xs: 14, sm: 16, md: 18}, // Responsive font size
                      fontWeight: '700',
                      lineHeight: '35px',
                      justifySelf: 'center',
                    }}
                  >
                    About Us
                  </Typography>
                </Link>
              </ListItemText>
            </ListItem>
            <ListItem button onClick={toggleDrawer}>
              <ListItemText>
                <Link to="/contact" onClick={toggleDrawer}>
                  <Typography
                    className="features-title"
                    sx={{
                      color: '#002367',
                      fontFamily: 'Light',
                      fontSize: {xs: 14, sm: 16, md: 18}, // Responsive font size
                      fontWeight: '700',
                      lineHeight: '35px',
                      justifySelf: 'center',
                    }}
                  >
                    Contact
                  </Typography>
                </Link>
              </ListItemText>
            </ListItem>
            <ListItem button onClick={toggleDrawer}>
              <ListItemText>
                <Link to="/register" onClick={toggleDrawer}>
                  <Typography
                    className="features-title"
                    sx={{
                      color: '#002367',
                      fontFamily: 'Light',
                      fontSize: {xs: 14, sm: 16, md: 18}, // Responsive font size
                      fontWeight: '700',
                      lineHeight: '35px',
                      justifySelf: 'center',
                    }}
                  >
                    Register Organization
                  </Typography>
                </Link>
              </ListItemText>
            </ListItem>
            <ListItem button onClick={toggleDrawer}>
              <ListItemText>
                <Link to="/privacy-policy" onClick={toggleDrawer}>
                  <Typography
                    className="features-title"
                    sx={{
                      color: '#002367',
                      fontFamily: 'Light',
                      fontSize: {xs: 14, sm: 16, md: 18}, // Responsive font size
                      fontWeight: '700',
                      lineHeight: '35px',
                      justifySelf: 'center',
                    }}
                  >
                    Privacy Policy
                  </Typography>
                </Link>
              </ListItemText>
            </ListItem>;

          </List>
        </Box>
      </Drawer>
    </AppBar>
  );
};

export default Navbar;
